// Y-perspective for the rooms and yards (2026-09-18): the same rule the street uses, without the
// real-world scale — she is the flat 240-px art at the bottom of the screen (nearScale 1) and
// shrinks towards the back wall / far fence (farScale), moving slower on the way (WalkController
// scales her speed by the same number). One profile per scene, keyed like the placement floors:
// `refY` is where her feet are at the far edge of the walkable floor, `nearY` the bottom of the frame.
import { FLOORS } from './floors.js';
import { DOWN_FLOOR, UP_FLOOR } from './gameHallLayout.js';
import { FLOOR as DRIVING_SCHOOL_FLOOR } from './drivingSchoolLayout.js';
import { FLOOR_Y as CAR_DEALER_FLOOR_CENTRE_Y } from './carDealerLayout.js';
import { FLOOR_Y as BIKE_SHOP_FLOOR_CENTRE_Y } from './bikeShopLayout.js';

const NEAR_FEET_Y = 720;              // GAME_HEIGHT — config.js touches import.meta.env at load, so plain `node --test` cannot import it

export function roomPerspective(farFeetY, farScale, nearFeetY = NEAR_FEET_Y) {
  return { refY: farFeetY, nearY: nearFeetY, nearScale: 1, farScale };
}

const farOf = (polyline) => Math.min(...polyline.map(([, y]) => y));
const HALF_ART = 120;                 // the flat art's half height: a walker `floorY` is a sprite CENTRE

export const ROOM_PERSPECTIVE = {
  home:           roomPerspective(farOf(FLOORS.home.polyline), 0.8),
  second_floor:   roomPerspective(farOf(FLOORS.second_floor.polyline), 0.8),
  // the kitchen and the salon walk on WalkController's default floor (centre 475 → feet 595): a shallow room
  kitchen:        roomPerspective(475 + HALF_ART, 0.86),
  salon:          roomPerspective(475 + HALF_ART, 0.86),
  game_hall:      roomPerspective(farOf(DOWN_FLOOR), 0.75),
  game_hall_up:   roomPerspective(farOf(UP_FLOOR), 0.72),
  driving_school: roomPerspective(farOf(DRIVING_SCHOOL_FLOOR), 0.8),
  car_dealer:     roomPerspective(CAR_DEALER_FLOOR_CENTRE_Y + HALF_ART, 0.86),
  bike_shop:      roomPerspective(BIKE_SHOP_FLOOR_CENTRE_Y + HALF_ART, 0.86),
};
